import React, { Component, createRef } from "react"
import PropTypes from "prop-types"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux"
import { Link, withRouter, BrowserRouter as Router, NavLink as RouterNavLink } from "react-router-dom"
import * as moment from 'moment';
import { withTranslation } from "react-i18next"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getAllProjectClient, addClientNote, getClientNote, deleteClientNote, addClientAppointment, getFollowLeadTab, addActivityProjectFollowUp, addProjectLeadCallLog, getProjectLeadCallLog, addProjectLeadEmailLog, getProjectLeadEmailLog, getProjectLeadAct, getProjectLeadNote, addProjectLeadNote } from "../../../store/actions";
import { API_URL } from "../../../helpers/app_url";
import axios from "axios"
import smlogo from "../../../assets/img/rs-logo-sm.jpg"
import Select from "react-select"
import JoditEditor from 'jodit-react';
import gridView from "../../../assets/img/grid-view.png"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Label,
  Input,
  FormGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  CardFooter,
  CardTitle,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  InputGroup,
  Nav,
  NavItem,
  NavLink,
  CardHeader
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { map } from "lodash"
import RsCard from "components/Rscards/Rscard";
import RSBarChart from "components/charts/RSBarChart";
import RSPieChart from "components/charts/RSPieChart";
import RsAdNew from "components/buttons/Adnew";
import SaveButton from "components/buttons/save";
import RsLink from "components/buttons/rsLink";
import blocks from "plugins/projectOverview/blocks";
import Moment from "react-moment";
import AiButton from "components/buttons/aiBtn";
import projectIcon from "../../../assets/img/project-icon.png";
import clientIcon from "../../../assets/img/user-icon.png";
import leadIcon from "../../../assets/img/l-1.png";
import leadConversion from "../../../assets/img/conversion-icon.png";
import RsCardImgv2 from "components/Rscards/Rscard-imgv2";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import ActionActivity from "components/buttons/actionActivity";
import RsCardImgv4 from "components/Rscards/Rscard-imgv4";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from "primereact/dropdown";
import RichTextEditor from "components/dropdowns/ContentEditor";
import SafeField from "helpers/SafeField";
class ProjectClients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: "",
      client: '',
      appTypes: [],
      appPriories: [],
      appLocTypes: [],
      appointment: '',
      selectedMulti2: null,
      optionGroup1: [],
      checked: true,
      projecttopfive: [],
      activePeriod: 'Today',
      activePeriod2: 'Today',
      newLeads: [],
      newActivity: [],
       projectOptions:[],
      expandedRows: null,


    }
    this.toggleEmailCanvas = this.toggleEmailCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.toggleNoteCanvas = this.toggleNoteCanvas.bind(this);
    this.toggleAppointmentCanvas = this.toggleAppointmentCanvas.bind(this);
    this.handleNoteSubmit = this.handleNoteSubmit.bind(this)
    this.handelValidAppointment = this.handelValidAppointment.bind(this)
    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.toggleAssignmentNew = this.toggleAssignmentNew.bind(this);
    this.handleMulti2 = this.handleMulti2.bind(this)
    this.isAllCanavas = this.isAllCanavas.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.dt = createRef();
  }
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  toggleAllCanavas() {
    this.setState(prevState => ({
      isAll: !prevState.isAll
    }));
  }
  isAllCanavas = arg => {
    const lead = arg;
    const { onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog, onGetAllActLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
        campaignProjectGuid: lead?.project?.projectGuid,
        campaignProjectId: lead?.project?.id,
        contactName: lead.firstName + " " + lead.lastName,
        email: lead.email,
        mobile: lead.mobile
      },
    });

    
    onGetFollowLead(lead.leadId, lead?.project?.projectGuid);
    onGetNoteLead(lead.leadId, lead?.project?.projectGuid);
    onGetLeadCallLog(lead.leadId, lead?.project?.projectGuid);
    onGetLeadEmailLog(lead.leadId, lead?.project?.projectGuid);
    onGetAllActLead(lead.leadId, lead?.project?.projectGuid)
    this.toggleAllCanavas();
  };
  handleMulti2 = selectedMulti2 => {
    this.setState({ selectedMulti2 })
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }
  toggleAssignmentNew() {
    this.setState({ isAssignmentNew: !this.state.isAssignmentNew });

  }
  handleNoteSubmit(value) {
    this.props.addClientNote(value, this.props.history);
  }
  handelValidAppointment(value) {
    //
    this.props.addClientAppointment(value, this.props.history);

  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleEmail() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  toggleNote() {
    this.setState(prevState => ({
      isNote: !prevState.isNote
    }));
  }
  toggleApp() {
    this.setState(prevState => ({
      isApp: !prevState.isApp
    }));
  }
  toggleEmailCanvas() {
    this.setState({ client: "", isEmailEdit: false, isRight: !this.state.isRight });
    this.toggleEmail();
  }
  toggleNoteCanvas() {
    this.setState({ client: "", isNoteEdit: false, isNote: !this.state.isNote });
    this.toggleEmail();
  }
  toggleAppointmentCanvas() {
    this.setState({ client: "", isAppEdit: false, isApp: !this.state.isApp });
    this.toggleEmail();
  }
  componentDidMount() {
    const { ongGetAllProjectClient } = this.props;
    ongGetAllProjectClient(localStorage.getItem('userId'));
    const obj = JSON.parse(localStorage.getItem("authUser"));
     this.buildProjectOptions(this.props.allclients);
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
    axios.get(API_URL + 'AppointmentType/all', {
      headers: { Authorization: str }
    })
      .then(res => {
        const appTypes = res.data;
        this.setState({ appTypes });
      }),
      axios.get(API_URL + 'AppointmentPriority/all', {
        headers: { Authorization: str }
      })
        .then(res => {
          const appPriories = res.data;
          this.setState({ appPriories });
        }),
      axios.get(API_URL + 'AppointmentLocationType/all', {
        headers: { Authorization: str }
      })
        .then(res => {
          const appLocTypes = res.data;
          this.setState({ appLocTypes });
        })
    this.fetchOptions();


    this.fetchNewLead(1, 'Today');
    this.fetchNewActivity(1, 'Today');

    axios.get(`${API_URL}ProjectExt/getProjectCountByAgent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {

        this.setState({ totalProject: res.data.countProject, totalClient: res.data.countProjectClient, totalLead: res.data.countLead, totalLeadtoClient: res.data.countProjectLeadtoClient });
      });

    axios.get(`${API_URL}ProjectExt/getProjectTopFiveProjectsByAgent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ projecttopfive: res.data });
      });
  }

  componentDidUpdate(prevProps) {
  if (prevProps.allclients !== this.props.allclients) {
    this.buildProjectOptions(this.props.allclients);
  }
}
  toggleEmailCanvas = arg => {
    const client = arg;
    this.setState({
      client: {
        clientId: client.clientId,

      },
      isEmailEdit: true,
    });
    this.toggleEmail();
  };

  toggleNoteCanvas = arg => {
    const client = arg;
    this.setState({
      client: {
        clientId: client.clientId,

      },
      isEmailEdit: true,
    });
    this.toggleNote();
  };

  toggleAppointmentCanvas = arg => {
    const client = arg;
    this.setState({
      client: {
        clientId: client.clientId,
        firstName: client.firstName,
        lastName: client.lastName,

      },
      isAppEdit: true,
    });
    this.toggleApp();
  };
  handleSearch = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  getFilteredClients = () => {
    const { allclients } = this.props;
    const { searchQuery } = this.state;

    if (!searchQuery) {
      return allclients;
    }

    return allclients.filter((client) => {
      const query = searchQuery.toLowerCase();
      return (
        (client.firstName + " " + client.lastName).toLowerCase().includes(query) ||
        client.phone?.toLowerCase().includes(query) ||
        client.email?.toLowerCase().includes(query) ||
        client.project?.projectName?.toLowerCase().includes(query)
      );
    });
  };
  fetchOptions = async () => {
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj.resultData.bearerToken;
      const str = 'Bearer ' + token;
      const response = await axios.get(`${API_URL}ProjectExt/latestforagentnbroker/`, {
        params: {
          agentId: localStorage.getItem('userId'),
          brokerId: localStorage.getItem('brokerId'),
        },
        headers: {
          Authorization: str,
          "Content-Type": "application/json",
        },
      });

      const options = response.data.map((item) => ({
        value: item.id,
        label: item.projectName,
      }));

      this.setState({ optionGroup1: options, isLoading: false });
    } catch (error) {
      console.error("Error fetching options:", error);
      this.setState({ isLoading: false });
    }
  };
  handleInsertAi = (generatedText, setFieldValue) => {
    setFieldValue("projectAdditionalFeatureDescription", generatedText);
  };
  fetchNewActivity(days, periodLabel) {
    this.setState({ loading: true, activePeriod2: periodLabel });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem("userId"),
      day: days,
    };
    axios
      .get(`${API_URL}ProjectExt/getProjectActivityForDashboardByDay`, { headers, params })
      .then((response) => {
        this.setState({ newActivity: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });


  }

  fetchNewLead(days, periodLabel) {
    this.setState({ loading: true, activePeriod: periodLabel });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem("userId"),
      day: days,
    };
    axios
      .get(`${API_URL}ProjectExt/getProjectCampaignLeadForDashboardByDay`, { headers, params })
      .then((response) => {
        this.setState({ newLeads: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
   buildProjectOptions(leads) {
    if (!leads) return;
    const uniqueProjects = [...new Set(leads.map(l => l.project?.projectName).filter(Boolean))];
    this.setState({
      projectOptions: uniqueProjects.map(p => ({ label: p, value: p }))
    });
  }
  render() {
    const { allclients, isResponsive } = this.props;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { client, selectedMulti2, optionGroup1, isLoading, activePeriod, activePeriod2, newLeads, newActivity, totalClient, totalLead, totalLeadtoClient, totalProject, projecttopfive, expandedRows } = this.state;
    const selectedValue = '';
    const filteredClients = this.getFilteredClients();

    
    const reports = [
      { title: "# Active projects", iconClass: projectIcon, description: totalProject },
      {
        title: "# Clients",
        iconClass: clientIcon,
        description: totalClient,
      },
      {
        title: "Leads to client conversion",
        iconClass: leadConversion,
        description: totalLeadtoClient + "%",
      },

    ];
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Projects | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
            {/* Render Breadcrumbs */}

            <Row className="mb20 project-header">
              <Col lg="12">
                <Breadcrumbs
                  title={this.props.t("Projects")}
                  breadcrumbItem={this.props.t("Projects Clients")}
                />
              </Col>

              {/* <Col lg="6">
            
             </Col> */}
            </Row>
            <div className="d-flex justify-content-center gap-3 flex-wrap bg-yellow">

              {reports.map((report, key) => (
                <div key={key} className="flex-grow-1 flex-shrink-0" 
                 style={{
                      flexBasis: isResponsive ? "calc(90% - 1rem )" : "calc(20% - 1rem)",
                  }}
                >
                  <RsCardImgv4 key={key} title={report.title} description={report.description} iconClass={report.iconClass} isResponsive={isResponsive} />
                </div>
              ))}

            </div>
           


            <Row>

              <Col lg="12">
                <Card className="border-full mt-4">
                  <CardHeader>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="btn-group rl-group-btn" role="group">
                          <Link to="/pre-construction/my-project">
                            <button
                              type="button"
                              className={`btn btn-outline-secondary w-xs bt-filter-v2 active`}
                            >
                              <span className="d-flex align-items-center gap-2">
                                Grid View

                                <img src={gridView} style={{ height: 16 }} />
                              </span>
                            </button>
                          </Link>

                          <Link onClick={this.toggleAddNew}>
                            <button
                              type="button"
                              className={`btn  btn-outline-secondary w-xs bt-filter-v2`}
                            >
                              <span className="d-flex align-items-center gap-2">
                                Send Project Updates


                              </span>
                            </button>
                          </Link>
                        </div>

                      

                      </div>

                    


                    </div>

                  </CardHeader>
                  <CardBody>



                    <div className="clearfix"></div>
                    
                    {isResponsive ? (
                       <DataTable
            value={filteredClients}
            paginator
            rows={10}
            stripedRows
            responsiveLayout="scroll"
            expandedRows={expandedRows}
            onRowToggle={(e) => this.setState({ expandedRows: e.data })}
            rowExpansionTemplate={(client) => (
              <table className="table table-sm mb-0 bg-light">
                <tbody>
                  <tr>
                    <th>Project</th>
                    <td>{client?.project?.projectName || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Date</th>
                    <td>
                      {client.lastContact ? (
                        <Moment format="DD MMM YY">{client.lastContact}</Moment>
                      ) : (
                        "N/A"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Phone</th>
                    <td>{client.phone || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{client.email || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Workspace</th>
                    <td>
                      <Link
                        to={`/clients/dashbord/${client.clientId}/${client.clientGuid}`}
                        className="btn btn-action btn-sm"
                      >
                        Open
                      </Link>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          >
            <Column expander style={{ width: "3rem" }} />
             <Column
                header="#"
                body={(rowData, options) => options.rowIndex + 1}
                style={{ width: '60px' }}
              />
            <Column
              header="Name"
              body={(client) => (
                <div>
                  <strong>
                    {client.firstName} {client.lastName}
                  </strong>
                  <div className="text-muted small">{client.email}</div>
                </div>
              )}
            />
            <Column
              header="Project"
              body={(client) =>
                client?.project?.projectName ? client.project.projectName : ""
              }
            />
          </DataTable>
                    ):(
                       <DataTable
                    ref={this.dt}
                      value={filteredClients}
                      dataKey="clientId"
                      stripedRows
                      paginator
                      rows={10}
                      responsiveLayout="scroll"
                    >
                       <Column
    header="#"
    body={(rowData, options) => options.rowIndex + 1}
    style={{ width: '60px' }}
  />
                      {/* Name */}
                      <Column
                        header={this.props.t("Name")}
                         filter
                        showFilterMatchModes={false}  
                        showFilterOperator={false}     
                        showAddButton={false}       
                        showClearButton={false}  
                        body={(client) => (
                          <div className="row">
                            <div className="col-sm-10">
                              {client.firstName + " " + client.lastName}
                            </div>
                          </div>
                        )}

                      />

                      {/* Project */}
                    <Column
                    header={this.props.t("Project")}
                    body={(client) => client?.project ? client?.project?.projectName : ''}
                    filter
                    showFilterMatchModes={false}
                    showFilterOperator={false}
                    showAddButton={false}
                    showClearButton={false}
                     filterField="project.projectName"   
                      filterMatchMode="equals"           
                    filterElement={(options) => (
                      <Dropdown
                        value={options.value}
                        options={this.state.projectOptions}
                        onChange={(e) => options.filterApplyCallback(e.value)}
                        placeholder="Select Project"
                        showClear
                        className="p-column-filter"
                        style={{ minWidth: '12rem' }}
                      />
                    )}
                  />

                      {/* Date */}
                      <Column
                        header={this.props.t("Date")}
                        body={(client) => client.lastContact ? (
                          <Moment format="DD MMM YY">{client.lastContact}</Moment>
                        ) : ''}

                      />

                      {/* Phone */}
                      <Column
                        field="phone"
                          filter
                        showFilterMatchModes={false}  
                        showFilterOperator={false}     
                        showAddButton={false}       
                        showClearButton={false}  
                        header={this.props.t("Phone")}

                      />

                      {/* Email */}
                      <Column
                        field="email"
                        filter
                        showFilterMatchModes={false}  
                        filterMatchMode="contains"
                        showFilterOperator={false}     
                        showAddButton={false}       
                        showClearButton={false}  
                        header={this.props.t("Email")}

                      />

                      {/* Client Login */}
                      <Column
                      headerClassName="action-header"
                       header={
                        <div className="justify-content-end">
                          <RsLink
                            onClick={() => this.dt.current.reset()}
                            iconClass="bx bx-reset"
                            className="btn-light"
                          >
                             Reset all filters
                          </RsLink>
                        </div>
                      }
                        body={(client) => (
                          <Link
                            to={`/clients/dashbord/${client.clientId}/${client.clientGuid}`}
                            className="btn btn-action btn-sm"
                          >
                            Workspace
                          </Link>
                        )}
                      />
                    </DataTable>
                    )}
                   
                  </CardBody>
                </Card>
              </Col>

            </Row>


          </Container>

          <Offcanvas
            isOpen={this.state.isRight}
            direction="end"
            toggle={this.toggleEmailCanvas}
            style={{ width: 800 }}
          >
            <OffcanvasHeader toggle={this.toggleEmailCanvas}>
              Send Email
            </OffcanvasHeader>
            <OffcanvasBody>

            </OffcanvasBody>
          </Offcanvas>

          <Offcanvas
            isOpen={this.state.isNote}
            direction="end"
            toggle={this.toggleNoteCanvas}

          >
            <OffcanvasHeader toggle={this.toggleNoteCanvas}>
              Add Note
            </OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  noteTitle: (this.state && this.state.noteTitle) || "",
                  agentId: localStorage.getItem('userId'),
                  clientId: client.clientId
                }}
                validationSchema={Yup.object().shape({
                  noteTitle: Yup.string().max(1000, "Message Text must not exceed 1000").required("This is Required")
                })}

                onSubmit={this.handleNoteSubmit}
              >
                {({ errors, touched, values, handleChange, setFieldValue }) => (
                  <Form
                    className="needs-validation"
                  >

                    <Row>
                      <Col md="12">
                        <FormGroup className="mb-3">

                          <textarea
                            name="noteTitle"
                            onChange={handleChange}
                            type="textarea"
                            className={
                              "form-control" +
                              (errors.noteTitle && touched.noteTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="noteTitle"
                          />
                          <ErrorMessage
                            name="noteTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>

          <Offcanvas
            isOpen={this.state.isApp}
            direction="end"
            toggle={this.toggleAppointmentCanvas}

          >
            <OffcanvasHeader toggle={this.toggleAppointmentCanvas}>
              Add Appointment
            </OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  appointmentTitle: (this.state && this.state.appointmentTitle) || "",
                  appointmentStartDate: (this.state && this.state.appointmentStartDate) || "",
                  startTime: (this.state && this.state.startTime) || "",
                  projectAdditionalFeatureDescription: '',
                  endTime: (this.state && this.state.endTime) || "",
                  contactName: client.firstName + " " + client.lastName,
                  contactPhone: '1234567890',
                  contactEmail: 'mohit@esimplified.ca',
                  clientId: client.clientId,
                  agentId: localStorage.getItem('userId'),
                  addedBy: 'agent'


                }}


                validationSchema={Yup.object().shape({
                  appointmentTitle: Yup.string().required("This is Required"),
                  appointmentStartDate: Yup.string().required("This is Required"),
                  startTime: Yup.string().required("This is Required"),
                  endTime: Yup.string().required("This is Required")
                })}

                onSubmit={this.handelValidAppointment}
              >
                {({ errors, touched, values, handleChange, handelBlur, setFieldValue }) => (
                  <Form
                    className="needs-validation"
                  >
                    <Row>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Agenda")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"
                            value={values.appointmentTitle}
                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb15">

                          <Label htmlFor="appointmentStartDate">
                            {this.props.t("Date")}
                          </Label>
                          <Flatpickr
                            className={
                              "form-control" +
                              (errors.appointmentStartDate && touched.appointmentStartDate
                                ? " is-invalid"
                                : "")
                            }


                            onChange={(value) => setFieldValue('appointmentStartDate', value[0])}
                            options={{
                              altInput: false,
                              minDate: "today",
                              altFormat: "F j, Y",
                              dateFormat: "Y-m-d"
                            }}
                          />
                          <ErrorMessage
                            name="appointmentStartDate"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb15">

                          <Label htmlFor="startTime">
                            {this.props.t("Start Time")}
                          </Label>
                          <InputGroup>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.startTime && touched.startTime
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder="Select time"

                              onChange={(value) => setFieldValue('startTime', value[0])}
                              options={{
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "h:i"
                              }}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <i className="mdi mdi-clock-outline" />
                              </span>
                            </div>
                            <ErrorMessage
                              name="startTime"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>

                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb15">

                          <Label htmlFor="endTime">
                            {this.props.t("End Time")}
                          </Label>
                          <InputGroup>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.endTime && touched.endTime
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder="Select time"
                              onChange={(value) => setFieldValue('endTime', value[0])}
                              options={{
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "h:i"
                              }}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <i className="mdi mdi-clock-outline" />
                              </span>
                            </div>
                            <ErrorMessage
                              name="endTime"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>

                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup className="mb15">

                          <Label htmlFor="appointmentType">
                            {this.props.t("Appointment Type")}
                          </Label>
                          <SafeField as="select" name="appointmentType" className="form-control" onChange={handleChange}>
                            <option value="">Select</option>
                            {
                              this.state.appTypes
                                .map(appType =>
                                  <option key={appType.id} value={appType.id}>{appType.appointmentTypeTitle}</option>
                                )
                            }
                          </SafeField>

                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup className="mb15">

                          <Label htmlFor="appointmentPriority">
                            {this.props.t("Priority")}
                          </Label>
                          <SafeField as="select" name="appointmentPriority" className="form-control" onChange={handleChange}>
                            <option value="">Select</option>
                            {
                              this.state.appPriories
                                .map(appPriorie =>
                                  <option key={appPriorie.id} value={appPriorie.id}>{appPriorie.appointmentPriorityTitle}</option>
                                )
                            }
                          </SafeField>

                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup className="mb15">

                          <Label htmlFor="appointmentLocationType">
                            {this.props.t("Location Type")}
                          </Label>
                          <SafeField as="select" name="appointmentLocationType" className="form-control" onChange={handleChange}>
                            <option value="">Select</option>
                            {
                              this.state.appLocTypes
                                .map(appLocType =>
                                  <option key={appLocType.id} value={appLocType.id}>{appLocType.appointmentLocationTypeTitle}</option>
                                )
                            }
                          </SafeField>

                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup className="mb15">
                          {(() => {
                            if (selectedValue == 3) {
                              return (
                                <>
                                  <Label htmlFor="appointmentLocation">
                                    {this.props.t("Location")}
                                  </Label>

                                </>
                              )
                            } else if (selectedValue == 2) {
                              return (
                                <>
                                  <Label htmlFor="appointmentLocation">
                                    {this.props.t("Phone")}
                                  </Label>

                                </>
                              )
                            } else {
                              return (
                                <>
                                  <Label htmlFor="appointmentLocation">
                                    {this.props.t("Online Link / Address")}
                                  </Label>

                                </>
                              )
                            }
                          })()}
                          <SafeField
                            name="appointmentLocation"
                            onChange={handleChange}
                            type="text"

                            className={
                              "form-control" +
                              (errors.appointmentLocation && touched.appointmentLocation
                                ? " is-invalid"
                                : "")
                            }

                            id="appointmentLocation"
                          />



                        </FormGroup>

                      </Col>
                    </Row>




                    <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>
                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>



          <Offcanvas
            isOpen={this.state.isAddNew}
            direction="end"
            toggle={this.toggleAddNew}
            style={{ width: 800 }}

          >
            <OffcanvasHeader toggle={this.toggleAddNew}>
              Send Project Updates
            </OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  noteTitle: (this.state && this.state.noteTitle) || "",
                  agentId: localStorage.getItem('userId'),
                  clientId: client.clientId
                }}
                validationSchema={Yup.object().shape({
                  noteTitle: Yup.string().max(1000, "Message Text must not exceed 1000").required("This is Required")
                })}

                onSubmit={this.handleNoteSubmit}
              >
                {({ errors, touched, values, handleChange, setFieldValue }) => (
                  <Form
                    className="needs-validation"
                  >

                    <Row>
                      <Col md="12">
                        <FormGroup className="mb15">

                          <Label htmlFor="selectProject">
                            {this.props.t("Select Project")}
                          </Label>
                          <Select
                            value={selectedMulti2}
                            isMulti={false}
                            onChange={this.handleMulti2}
                            options={optionGroup1}
                            classNamePrefix="select2-selection"
                            isLoading={isLoading}
                          />

                        </FormGroup>
                      </Col>
                      {/* <Col md="12">
                            <h5># Client : 10</h5>
                          </Col> */}

                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Email Subject")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup className="mb-3">
                          <label style={{ display: blocks, width: "100%" }}>
                            {this.props.t("Email Body")}

                            <span className="float-end" style={{ marginRight: 10 }}> <AiButton onInsert={(text) => this.handleInsertAi(text, setFieldValue)} /> </span>
                          </label>
                             <RichTextEditor
                            name="notes"
                            setFieldValue={setFieldValue}
                            initialContent={values.notes}
                            placeholder="Enter email content here..."
                          />
                         
                          <ErrorMessage
                            name="noteTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <SaveButton iconClass=" bx bx-mail-send">Send</SaveButton>{" "}
                    <RsLink iconClass=" bx bx-mail-send">Send Preview email</RsLink>{" "}
                    <RsLink>Cancel</RsLink>

                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>


          <Offcanvas
            isOpen={this.state.isAssignmentNew}
            direction="end"
            toggle={this.toggleAssignmentNew}

          >
            <OffcanvasHeader toggle={this.toggleAssignmentNew}>
              Assignment Sale
            </OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  noteTitle: (this.state && this.state.noteTitle) || "",
                  agentId: localStorage.getItem('userId'),
                  clientId: client.clientId
                }}
                validationSchema={Yup.object().shape({
                  noteTitle: Yup.string().max(1000, "Message Text must not exceed 1000").required("This is Required")
                })}

                onSubmit={this.handleNoteSubmit}
              >
                {({ errors, touched, values, handleChange, setFieldValue }) => (
                  <Form
                    className="needs-validation"
                  >

                    <Row>


                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Asking Price")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Original Purchase Price")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Deposits Paid")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Deposit Requirement")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Development Cap")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Upgrades")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Builders Occupancy Fees")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Condo/POTL Fees")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Property Taxes")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="appointmentTitle">
                            {this.props.t("Total Occupancy Fees")}
                          </Label>
                          <input
                            name="appointmentTitle"
                            type="text"

                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.appointmentTitle && touched.appointmentTitle
                                ? " is-invalid"
                                : "")
                            }
                            id="appAjenda"
                          />
                          <ErrorMessage
                            name="appointmentTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <SaveButton>Submit</SaveButton>{" "}


                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>

        </div>
      </React.Fragment>
    )
  }
}

ProjectClients.propTypes = {

  className: PropTypes.any,
  t: PropTypes.any,
  history: PropTypes.object,
  ongGetAllProjectClient: PropTypes.func,
  allclients: PropTypes.array,
  loading: PropTypes.object,
  match: PropTypes.object,
  addClientNote: PropTypes.func,
  addClientAppointment: PropTypes.func,
  onGetNoteLead: PropTypes.func,
  onGetFollowLead: PropTypes.func,
  leadFollows: PropTypes.array,
  onAddLeadFollowUp: PropTypes.func,
  onGetLeadEmailLog: PropTypes.func,
  onGetLeadCallLog: PropTypes.func,
  notes: PropTypes.array,
  calllogs: PropTypes.array,
  emaillogs: PropTypes.array,
  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  onGetAllActLead: PropTypes.func,
  isResponsive:PropTypes.object

}

const mapStateToProps = ({ Project, projectleads }) => ({
  allclients: Project.allclients,
  loading: Project.loading,

  activities: projectleads.activities,
  followups: projectleads.followups,
  notes: projectleads.notes,
  calllogs: projectleads.calllogs,
  emaillogs: projectleads.emaillogs,
  leadFollows: projectleads.leadFollows
})

const mapDispatchToProps = dispatch => ({
  ongGetAllProjectClient: (agentId) => dispatch(getAllProjectClient(agentId)),
  addClientNote: (data) => dispatch(addClientNote(data)),
  addClientAppointment: (data) => dispatch(addClientAppointment(data)),

  onAddLeadNote: (data) => dispatch(addProjectLeadNote(data)),
  onGetNoteLead: (leadId, projectGuid) => dispatch(getProjectLeadNote(leadId, projectGuid)),
  onGetFollowLead: (leadId) => dispatch(getFollowLeadTab(leadId)),

  onAddLeadFollowUp: (data) => dispatch(addActivityProjectFollowUp(data)),
  onAddCallLog: (data) => dispatch(addProjectLeadCallLog(data)),
  onGetLeadCallLog: (leadId, projectGuid) => dispatch(getProjectLeadCallLog(leadId, projectGuid)),
  onAddEmailLog: (data) => dispatch(addProjectLeadEmailLog(data)),
  onGetLeadEmailLog: (leadId, projectGuid) => dispatch(getProjectLeadEmailLog(leadId, projectGuid)),
  onGetAllActLead: (leadId, projectGuid) => dispatch(getProjectLeadAct(leadId, projectGuid)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(ProjectClients)))